<template>
  <el-dialog title="引用课题元数据" :visible.sync="visiable" width="640px" :before-close="() => (visiable = false)">
    <div class="data-share-modal" v-loading="initLoading" element-loading-text="生成中">
      <div class="tip-text">
        <span>复制课题</span>
        <span
          >案例的元数据链接或下载数据二维码（手机扫描即可查看）附在您的文章或论文里面，使您的研究数据可被读者验证，增强您研究的严谨性和可信度。</span
        >
      </div>
      <div class="content">
        <div class="link-content">
          <div class="link-content-item">
            <div class="link-item-title" :style="{ lineHeight: '32px' }">下载方式</div>
            <div class="link-item-info">
              <el-select v-model="downloadType" @change="initHandle">
                <el-option
                  v-for="typeItem in metadataTypes"
                  :key="typeItem.value"
                  :value="typeItem.value"
                  :label="typeItem.label"
                />
              </el-select>
            </div>
          </div>
          <div class="link-content-item">
            <div class="link-item-title">元数据链接</div>
            <div class="link-item-info">
              <a class="link-url" :href="linkUrl" download>{{ linkUrl }}</a>
            </div>
          </div>
          <div class="link-content-item">
            <el-button type="primary" v-copy="linkUrl" v-copy:callback="handleCopied">复制链接</el-button>
          </div>
        </div>
        <div class="img-content">
          <div class="img-title">元数据二维码</div>
          <img class="data-img" :src="imgUrl" />
          <div class="down-btn-content">
            <a class="down-btn" :href="imgUrl" :download="`${xlsTitle}元数据二维码.png`" target="blank">
              <span>下载二维码</span>
            </a>
          </div>
        </div>
        <div class="tip-conetnt">
          <span
            >特别提示：以上的元数据链接和二维码只记录当前筛选条件下的图表数据。如筛选条件改变，需重新生成元数据链接。建议确定最终的图表后，才复制链接或下载二维码。</span
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { services } from '@/service';
import { formatDataSourceHandle } from '@/lib/utils';
import { metadataTypes } from '@/constant';

export default {
  data() {
    return {
      initLoading: false,
      linkUrl: '',
      imgUrl: '',
      downloadType: metadataTypes[0].value,
      metadataTypes
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    visiable: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    xlsTitle() {
      return this.courseDetail._source.title;
    }
  },
  mounted() {
    this.initHandle();
  },
  methods: {
    handleCopied(url) {
      if (url) {
        this.$message.success('链接复制成功');
      }
    },
    async initHandle() {
      try {
        this.initLoading = true;
        const query = formatDataSourceHandle({ query: [] }).query;
        const params = {
          courseware_id: this.courseDetail._id,
          title: this.xlsTitle,
          query,
          downloadType: this.downloadType
        };
        const { path, image_b64: imageB64 } = await services.courseware.downMetadata(params);
        this.linkUrl = path;
        this.imgUrl = imageB64;
        this.initLoading = false;
      } catch (err) {
        this.$error(err);
        this.visiable = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.data-share-modal {
  .tip-text {
    color: #2c3443;
    font-size: 14px;
    line-height: 20px;
  }

  .content {
    display: flex;
    margin: 20px 0 10px;
    flex-wrap: wrap;
    .link-content {
      box-sizing: border-box;
      flex: 1;
      width: 0;
      background-color: #f8fafd;
      border-radius: 4px;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 20px;

      .link-title {
        color: #2c3443;
        margin: 0 0 15px;
        font-weight: 500;
      }

      .link-url {
        color: #1991fb;
        text-decoration: none;
        @include mulit-ellipsis(3);
      }
      .link-content-item {
        display: flex;
        align-items: flex-start;
        margin-top: 15px;

        .link-item-title {
          width: 80px;
          color: #2c3443;
        }

        .link-item-info {
          flex: 1;
          width: 0;
        }
      }
    }
    .img-content {
      box-sizing: border-box;
      width: 200px;
      text-align: center;
      margin-left: 20px;
      background-color: #f8fafd;
      border-radius: 4px;
      padding: 10px 0;

      .img-title {
        color: #2c3443;
        font-weight: 500;
      }

      .data-img {
        width: 120px;
        height: 120px;
        margin: 6px 0;
      }

      .down-btn-content {
        .down-btn {
          font-size: 14px;
          text-decoration: none;
          color: #1991fb;
        }
      }
    }

    .tip-conetnt {
      width: 100%;
      font-size: 12px;
      line-height: 17px;
      color: #77839e;
      margin-top: 10px;

      & > span {
        font-weight: 300;
      }
    }
  }
}
</style>
